<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="发货预测名称">
              <global-select
                :value.sync="queryParams.shipmentForecastName"
                selectType="select"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                :value.sync="queryParams.shipmentForecastVersionList"
                selectType="select"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <global-select
                :value.sync="queryParams.statusList"
                selectType="select"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastStatus"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['mdm:mdmUomConversions:add']"
      >导出明细</a-button
      >
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          :bordered="true"
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

    <script>
import { apiMdmUomConversionsList } from '@/api/mdm/units/standard-unit'
import { generateLsTableResData } from '@/utils/util.js'
export default {
  // eslint-disable-next-line
  name: 'comparison',
  components: {},
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMdmUomConversionsList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: '',
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        shipmentForecastName: undefined,
        shipmentForecastVersionList: undefined,
        statusList: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 状态快码
      statusOptions: [
        {
          dictLabel: '有效',
          dictValue: 'Y'
        },
        {
          dictLabel: '无效',
          dictValue: 'N'
        }
      ],
      baseUomFlagOptions: [
        {
          dictLabel: '是',
          dictValue: 'Y'
        },
        {
          dictLabel: '否',
          dictValue: 'N'
        }
      ],
      // 表格字段
      columns: [
        {
          title: '物料编码',
          dataIndex: 'uomClass',
          align: 'center',
          width: 100
        },
        {
          title: '20230804发货预测',
          children: [
            {
              title: 'M+0',
              dataIndex: 'conversionRate',
              width: 120,
              scopedSlots: { customRender: 'conversionRate' },
              align: 'center'
            },
            {
              title: 'M+1',
              dataIndex: 'conversionRateInverse',
              scopedSlots: { customRender: 'conversionRateInverse' },
              ellipsis: true,
              align: 'center'
            },
            {
              title: 'M+2',
              dataIndex: 'baseUnitOfMeasure',
              ellipsis: true,
              align: 'center'
            },
            {
              title: 'M+3',
              dataIndex: 'status',
              scopedSlots: { customRender: 'status' },
              align: 'center'
            },
            {
              title: 'M+4',
              dataIndex: 'updateName',
              ellipsis: true,
              align: 'center'
            }
          ]
        },
        {
          title: '20230803发货预测',
          children: [
            {
              title: 'M+0',
              dataIndex: 'conversionRate',
              width: 120,
              scopedSlots: { customRender: 'conversionRate' },
              align: 'center'
            },
            {
              title: 'M+1',
              dataIndex: 'conversionRateInverse',
              scopedSlots: { customRender: 'conversionRateInverse' },
              ellipsis: true,
              align: 'center'
            },
            {
              title: 'M+2',
              dataIndex: 'baseUnitOfMeasure',
              ellipsis: true,
              align: 'center'
            },
            {
              title: 'M+3',
              dataIndex: 'status',
              scopedSlots: { customRender: 'status' },
              align: 'center'
            },
            {
              title: 'M+4',
              dataIndex: 'updateName',
              ellipsis: true,
              align: 'center'
            }
          ]
        },
        {
          title: '差异对比',
          children: [
            {
              title: 'M+0',
              dataIndex: 'conversionRate',
              width: 120,
              scopedSlots: { customRender: 'conversionRate' },
              align: 'center'
            },
            {
              title: 'M+1',
              dataIndex: 'conversionRateInverse',
              scopedSlots: { customRender: 'conversionRateInverse' },
              ellipsis: true,
              align: 'center'
            },
            {
              title: 'M+2',
              dataIndex: 'baseUnitOfMeasure',
              ellipsis: true,
              align: 'center'
            },
            {
              title: 'M+3',
              dataIndex: 'status',
              scopedSlots: { customRender: 'status' },
              align: 'center'
            },
            {
              title: 'M+4',
              dataIndex: 'updateName',
              ellipsis: true,
              align: 'center'
            }
          ]
        }
      ],
      uomClassOptions: [],
       unitOfMeasureList: [],
      unitOfMeasureListNew: []
    }
  },
  created () {
    this.getUnitOfMeasureList()
    const lookupQueryParams = {
      lookupType: 'MDM_UOM_CLASSES',
      current: 1,
      pageSize: 100
    }
    this.getLookupListData(lookupQueryParams)
      .then()
      .then((response) => {
        this.uomClassOptions = response.rows
      })
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    statusOnChange (record) {
      record.status = record.status === 'Y' ? 'N' : 'Y'
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download(
        'mdm/mdmUomConversions/export',
        {
          ...this.queryParams
        },
        `标准单位转换_${new Date().getTime()}.xlsx`
      )
    },
    // getUnitOfMeasureList () {
    //   unitOfMeasurelist().then((res) => {
    //     if (res.code === 200 && res.data && res.data.length > 0) {
    //       this.unitOfMeasureList = res.data
    //     }
    //   })
    //   unitOfMeasurelist({ baseUomFlag: 'Y', status: 'Y' }).then((res) => {
    //     if (res.code === 200 && res.data && res.data.length > 0) {
    //       this.unitOfMeasureListNew = res.data
    //     }
    //   })
    // },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      this.isEdit = true
      this.currentId = record.id
    },
    // 编辑-保存
    // handleSave (record) {
    //   if (!record.conversionRate || Number(record.conversionRate) <= 0) {
    //     this.$message.warning('折换不能为空且需大于0')
    //     return
    //   }
    //   updateUnit(record).then((response) => {
    //     if (response.code === 200) {
    //       this.$message.success('保存成功')
    //       this.onSearch()
    //       this.isEdit = false
    //     } else {
    //       this.$message.error(response.msg)
    //     }
    //   })
    // },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.dataTable.getData()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomList: undefined,
        status: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

    <style scoped lang="less">
.ml10 {
  margin-left: 10px;
}
</style>
